<div
  class="header"
  [hidden]="!showTileHeader()"
	[ngClass]="{
		'mod-history': isHistory,
		'mod-wallet-details': isWalletDetails
	}">
  <div class="header-title">
    <h3
      [id]="title"
      class="title"
      (click)="headerClickHandler()"
			[ngClass]="{
				'mod-clickable': isHeaderClickable
			}"
      >{{ title }}</h3
      >

      @if (titleAddition) {
        <span class="title-addition">{{ titleAddition }}</span>
      }

      @if (!!headerExtraInfo) {
        <span class="extra-info">{{ headerExtraInfo }}</span>
      }
      @if (link.length > 0) {
        <a [href]="link" [target]="'_blank'">
          @if (tooltip) {
            <span
              class="header-title-icon bpi__icon-info"
            [bp-tooltip]="tooltip | translate"></span>
          }
        </a>
      } @else {
        @if (tooltip) {
          <span
            class="header-title-icon bpi__icon-info"
            [bp-tooltip]="tooltip | translate"
            [position]="placement"
          [tabIndex]="0"></span>
        }
      }
    </div>
    <bp-info class="actions" #actionsRef>
      <ng-content select="[tile-actions]"></ng-content>
      @if (isHidePortfolioActive && isHeaderClickable) {
        <hide-portfolio-value-button screenItHappenedOn="home_screen"></hide-portfolio-value-button>
      }
    </bp-info>
  </div>
  <div
    class="sub-header"
	[ngClass]="{
		'mod-history': isHistory,
		'mod-wallet-details': isWalletDetails
	}">
    <ng-content select="[tile-info]"></ng-content>
  </div>
  <div [ngClass]="{ content: padding, 'mod-wallet-details': isWalletDetails }" class="{{ css }}">
    <ng-content></ng-content>
  </div>
